<template>
  <div class="container">
    <div class="title">
      <el-breadcrumb>
        <el-breadcrumb-item>业务管理</el-breadcrumb-item>
        <el-breadcrumb-item>工单管理</el-breadcrumb-item>
        <el-breadcrumb-item>Dcops工单</el-breadcrumb-item>
        <el-breadcrumb-item>服务器退役</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="建单时间">
                <el-date-picker
                  v-model="searchForm.create_time"
                  type="daterange"
                  range-separator="-"
                  style="width: 100%"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="handleDateChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="超时时间">
                <el-date-picker
                  v-model="searchForm.olaTime"
                  type="daterange"
                  range-separator="-"
                  style="width: 100%"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="handleOlaTimeChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工单ID">
                <el-input v-model="searchForm.TicketId" placeholder="请输入工单ID" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="时效">
                <el-select clearable v-model="searchForm.rd_olaTime" placeholder="请选择时效">
                  <el-option label="预超时" value="1" />
                  <el-option label="超时-进行中" value="2" />
                  <el-option label="超时-完成" value="3" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="区域-园区">
                <el-select clearable v-model="searchForm.Campus" placeholder="请选择" @focus="handleSelectFocus">
                  <el-option v-for="item in campusOptions" :key="item" :label="item" :value="item" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="状态分组">
                <el-select v-model="statusGroup" clearable placeholder="退役阶段">
                  <el-option label="进行中" value="in_progress" />
                  <el-option label="已完成/已终止" value="done" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="处理人">
                <el-input v-model="searchForm.ProcessUsers" placeholder="支持模糊搜索" clearable />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="search-button">
                <el-button type="primary" @click="handleSearch">点击查询</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <div class="title-en">服务器退役列表</div>
    <el-card class="box-card">
      <div class="table-container">
        <div class="button-container">
          <el-button type="success" plain :loading="syncLoading" :disabled="syncLoading" @click="openSyncDialog">更新退役列表</el-button>
          <el-button @click="openColumnsDialog">表头设置</el-button>
        </div>

        <el-table :data="showData" border stripe ref="table" v-loading="loading" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column
            v-for="(column, index) in visibleColumns"
            :key="index"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :align="column.align"
          >
            <template slot-scope="scope">
              <template v-if="column.prop === 'TicketId'">
                <span v-if="scope.row.TicketId">{{ scope.row.TicketId }}</span>
                <span v-else>-</span>
              </template>
              <template v-else-if="column.prop === 'InstanceStatus'">
                <el-tag :type="statusTagType(scope.row.InstanceStatus)" size="small">{{ scope.row.InstanceStatus || '-' }}</el-tag>
              </template>
              <template v-else-if="column.prop === 'SlaOffset'">
                <span :class="slaOffsetClass(scope.row)">{{ formatSlaOffset(scope.row) }}</span>
              </template>
              <template v-else-if="column.prop === 'RetireTimeline'">
                <div class="life-cycle">
                  <div class="life-step">
                    <div class="life-dot on" />
                    <div class="life-step-meta">
                      <div class="life-step-title">起单</div>
                      <div class="life-step-time">{{ formatLifeCycleTime(scope.row.SocDispatchTime) }}</div>
                    </div>
                  </div>
                  <div class="life-line" :class="{ on: !!scope.row.SocDispatchTime && !!scope.row.CheckPointTime }" />

                  <div class="life-step">
                    <div class="life-dot" :class="{ on: !!scope.row.CheckPointTime }" />
                    <div class="life-step-meta">
                      <div class="life-step-title">状态更新</div>
                      <div class="life-step-time">{{ formatLifeCycleTime(scope.row.CheckPointTime) }}</div>
                    </div>
                  </div>
                  <div class="life-line" :class="{ on: !!scope.row.CheckPointTime && !!scope.row.PullOutTime }" />

                  <div class="life-step">
                    <div class="life-dot" :class="{ on: !!scope.row.PullOutTime }" />
                    <div class="life-step-meta">
                      <div class="life-step-title">拔盘完成</div>
                      <div class="life-step-time">{{ formatLifeCycleTime(scope.row.PullOutTime) }}</div>
                    </div>
                  </div>
                  <div class="life-duration">耗时：{{ formatRetireDuration(scope.row) }}</div>
                </div>
              </template>
              <span v-else>{{ formatCell(scope.row, column.prop) }}</span>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog title="选择月份范围" :visible.sync="monthSelectDialogVisible" width="700px" :close-on-click-modal="false">
          <el-form :model="monthSelectForm" label-width="100px">
            <el-form-item label="开始月份">
              <el-date-picker v-model="monthSelectForm.startMonth" type="month" placeholder="选择开始月份" value-format="yyyy-MM" />
            </el-form-item>
            <el-form-item label="结束月份">
              <el-date-picker v-model="monthSelectForm.endMonth" type="month" placeholder="选择结束月份" value-format="yyyy-MM" />
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="monthSelectDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="confirmSyncMonthSelect">确定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="设置显示项" :visible.sync="showColumnsDialog" width="420px" :close-on-click-modal="false">
          <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
            <el-checkbox v-for="column in columns" :key="column.prop" :label="column.prop" class="checkbox-item">
              {{ column.label }}
            </el-checkbox>
          </el-checkbox-group>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="selectAllColumns">全选</el-button>
            <el-button size="small" @click="restoreDefaultColumns">恢复默认</el-button>
            <el-button size="small" type="primary" @click="saveColumnsDialog">保存</el-button>
          </div>
        </el-dialog>

        <div class="pagination-container">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import * as XLSX from 'xlsx';
import {
  getDcopsRetireCampusOptions,
  getServerRetireList,
  UpdateServerRetireList,
} from '@/api/dcopsTicket';
import dcopsTicketSyncLoading from '@/mixins/dcopsTicketSyncLoading';

const DATE_FIELDS = ['SocDispatchTime', 'CheckPointTime', 'PullOutTime', 'OlaTime'];

export default {
  name: 'DcopsServerRetire',
  mixins: [dcopsTicketSyncLoading],
  data() {
    const cols = [
      { prop: 'TicketId', label: 'dcops单号', width: 150 },
      { prop: 'ProcessTitle', label: '工单标题', width: 280 },
      { prop: 'InstanceStatus', label: '当前状态', width: 140 },
      { prop: 'SlaOffset', label: 'SLA偏移', width: 130 },
      { prop: 'Amount', label: '每单台数', width: 90 },
      { prop: 'Campus', label: '园区', width: 120 },
      { prop: 'RetireTimeline', label: '退役阶段时间线', width: 475 },
      { prop: 'PullOutTime', label: '拔/盘卡完成时间', width: 165 },
      { prop: 'SocDispatchTime', label: '起单时间', width: 165 },
      { prop: 'CheckPointTime', label: '状态更新时间', width: 165 },
      { prop: 'IdcpName', label: '一级机房', width: 150 },
      { prop: 'IdcName', label: '机房单元', width: 180 },
      { prop: 'ProcessUsers', label: '当前处理人', width: 160 },
      { prop: 'SupplierName', label: '服务商名称', width: 120 },
      { prop: 'SupplierContactName', label: '服务商联系人', width: 140 },
      { prop: 'OlaTime', label: '超时时间', width: 165 },
    ];
    const defaults = [
      'TicketId',
      'ProcessTitle',
      'InstanceStatus',
      'SlaOffset',
      'Amount',
      'Campus',
      'RetireTimeline',
      'IdcpName',
      'ProcessUsers',
      'SupplierName',
      'OlaTime',
    ];
    return {
      columns: cols,
      selectedColumns: [...defaults],
      defaultSelectedColumns: [...defaults],
      visibleColumns: [],
      selectedRows: [],
      showData: [],
      dcopsSyncKey: 'retire',
      loading: false,
      exportLoading: false,
      hasLoaded: false,
      campusOptions: [],
      monthSelectDialogVisible: false,
      showColumnsDialog: false,
      monthSelectForm: {
        startMonth: this.$moment().subtract(1, 'month').format('YYYY-MM'),
        endMonth: this.$moment().format('YYYY-MM'),
      },
      statusGroup: '',
      searchForm: {
        create_time: [],
        olaTime: [],
        start_time: null,
        end_time: null,
        olaStartTime: null,
        olaEndTime: null,
        TicketId: '',
        Campus: '',
        ProcessUsers: '',
        rd_olaTime: '',
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
    };
  },
  created() {
    const now = new Date();
    const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
    const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    this.searchForm.create_time = [
      this.$moment(startDate).format('YYYY-MM-DD'),
      this.$moment(endDate).format('YYYY-MM-DD'),
    ];
    this.handleDateChange(this.searchForm.create_time);
    this.handleOlaTimeChange([this.searchForm.olaStartTime, this.searchForm.olaEndTime]);
    this.visibleColumns = this.columns.filter((x) => this.selectedColumns.includes(x.prop));
    this.fetchRetireData();
    this.getCampusData();
    this.debouncedExport = debounce(this.handleExport, 300);
  },
  methods: {
    statusTagType(status) {
      if (!status) return '';
      if (['盘/卡入库完成', '终止', '已终止'].includes(status)) return 'success';
      if (status.includes('中')) return 'warning';
      return '';
    },
    formatTime(value) {
      if (!value) return '-';
      const m = this.$moment(value);
      return m.isValid() ? m.format('YYYY-MM-DD HH:mm:ss') : String(value);
    },
    formatLifeCycleTime(value) {
      if (!value) return '-';
      const m = this.$moment(value);
      return m.isValid() ? m.format('MM-DD HH:mm') : String(value);
    },
    formatRetireDuration(row) {
      if (!row || !row.SocDispatchTime || !row.PullOutTime) return '-';
      const start = this.$moment(row.SocDispatchTime);
      const end = this.$moment(row.PullOutTime);
      if (!start.isValid() || !end.isValid() || end.isBefore(start)) return '-';
      const totalMins = end.diff(start, 'minutes');
      const days = Math.floor(totalMins / (24 * 60));
      const hours = Math.floor((totalMins % (24 * 60)) / 60);
      const mins = totalMins % 60;
      return `${days}天${hours}小时${mins}分钟`;
    },
    formatCell(row, prop) {
      const val = row ? row[prop] : null;
      if (val === null || val === undefined || val === '') return '-';
      if (DATE_FIELDS.includes(prop)) return this.formatTime(val);
      return String(val);
    },
    formatSlaOffset(row) {
      if (!row || !row.OlaTime || !row.CheckPointTime) return '-';
      const ola = this.$moment(row.OlaTime);
      const cp = this.$moment(row.CheckPointTime);
      if (!ola.isValid() || !cp.isValid()) return '-';
      const diffMins = cp.diff(ola, 'minutes');
      if (diffMins === 0) return '准点';
      const prefix = diffMins > 0 ? '超时' : '提前';
      const abs = Math.abs(diffMins);
      const h = Math.floor(abs / 60);
      const m = abs % 60;
      return `${prefix} ${h}h${m}m`;
    },
    slaOffsetClass(row) {
      const txt = this.formatSlaOffset(row);
      if (txt.startsWith('超时')) return 'sla-overdue';
      if (txt.startsWith('提前')) return 'sla-ahead';
      return '';
    },
    handleSelectFocus() {
      if (!this.hasLoaded) {
        this.getCampusData();
      }
    },
    async getCampusData() {
      try {
        const res = await getDcopsRetireCampusOptions();
        if (res.data && res.data.code === 200) {
          const raw = (res.data.data && res.data.data.campus_list) || [];
          this.campusOptions = Array.from(new Set(raw.filter(Boolean)));
          this.hasLoaded = true;
        }
      } catch (e) {
        console.error(e);
      }
    },
    handleOlaTimeChange(val) {
      if (Array.isArray(val) && val.length === 2 && val[0] && val[1]) {
        this.searchForm.olaStartTime = val[0];
        this.searchForm.olaEndTime = `${val[1]} 23:59:59`;
      } else {
        this.searchForm.olaStartTime = null;
        this.searchForm.olaEndTime = null;
      }
    },
    handleDateChange(val) {
      if (Array.isArray(val) && val.length === 2 && val[0] && val[1]) {
        this.searchForm.start_time = val[0];
        this.searchForm.end_time = `${val[1]} 23:59:59`;
      } else {
        this.searchForm.start_time = null;
        this.searchForm.end_time = null;
      }
    },
    fetchRetireData() {
      this.loading = true;
      const rawParams = {
        page: this.currentPage,
        size: this.pageSize,
        statusGroup: this.statusGroup,
        ...this.searchForm,
      };
      delete rawParams.create_time;
      delete rawParams.olaTime;
      const params = Object.fromEntries(
        Object.entries(rawParams).filter(([, value]) => {
          if (value === '' || value === null || value === undefined) return false;
          if (Array.isArray(value) && value.length === 0) return false;
          return true;
        }),
      );
      getServerRetireList(params)
        .then((res) => {
          if (res.data.code === 200) {
            this.showData = res.data.data.data || [];
            this.total = res.data.data.total || 0;
          } else {
            this.$message.error(res.data.message || '获取列表失败');
          }
          this.loading = false;
        })
        .catch((err) => {
          console.error(err);
          this.$message.error('获取列表失败');
          this.loading = false;
        });
    },
    onDcopsSyncFinished() {
      this.fetchRetireData();
      this.getCampusData();
    },
    openSyncDialog() {
      this.monthSelectDialogVisible = true;
    },
    confirmSyncMonthSelect() {
      if (!this.monthSelectForm.startMonth || !this.monthSelectForm.endMonth) {
        this.$message.warning('请选择开始月份和结束月份');
        return;
      }
      this.monthSelectDialogVisible = false;
      UpdateServerRetireList({
        start_month: this.monthSelectForm.startMonth,
        end_month: this.monthSelectForm.endMonth,
      })
        .then((res) => {
          this.handleDcopsSyncResponse(res, () => {
            this.fetchRetireData();
            this.getCampusData();
          });
        })
        .catch((err) => {
          console.error(err);
          this.$message.error('同步请求失败');
        });
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchRetireData();
    },
    handleReset() {
      const now = new Date();
      const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
      const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      this.statusGroup = '';
      this.searchForm = {
        create_time: [
          this.$moment(startDate).format('YYYY-MM-DD'),
          this.$moment(endDate).format('YYYY-MM-DD'),
        ],
        olaTime: [],
        start_time: null,
        end_time: null,
        olaStartTime: null,
        olaEndTime: null,
        TicketId: '',
        Campus: '',
        ProcessUsers: '',
        rd_olaTime: '',
      };
      this.handleOlaTimeChange(null);
      this.handleDateChange(this.searchForm.create_time);
      this.currentPage = 1;
      this.fetchRetireData();
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchRetireData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchRetireData();
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
      this.visibleColumns = this.columns.filter((x) => this.selectedColumns.includes(x.prop));
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((x) => x.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
    async handleExport() {
      if (this.exportLoading) return;
      this.exportLoading = true;
      this.loading = true;
      try {
        const rawExport = {
          export_excel: '1',
          statusGroup: this.statusGroup,
          ...this.searchForm,
        };
        delete rawExport.create_time;
        delete rawExport.olaTime;
        const params = Object.fromEntries(
          Object.entries(rawExport).filter(([, value]) => {
            if (value === '' || value === null || value === undefined) return false;
            if (Array.isArray(value) && value.length === 0) return false;
            return true;
          }),
        );
        const sourceRows = this.selectedRows.length ? this.selectedRows : (await getServerRetireList(params)).data.data.data || [];
        const rows = sourceRows.map((row) => {
          const out = {};
          this.visibleColumns.forEach((col) => {
            if (col.prop === 'SlaOffset') out[col.label] = this.formatSlaOffset(row);
            else if (col.prop === 'RetireTimeline') out[col.label] = `起单:${this.formatTime(row.SocDispatchTime)}；状态更新时间:${this.formatTime(row.CheckPointTime)}；拔盘完成:${this.formatTime(row.PullOutTime)}`;
            else out[col.label] = this.formatCell(row, col.prop);
          });
          return out;
        });
        const ws = XLSX.utils.json_to_sheet(rows);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, '服务器退役列表');
        XLSX.writeFile(wb, `服务器退役列表_${this.$moment().format('YYYYMMDDHHmmss')}.xlsx`);
        this.$message.success('导出成功');
      } catch (e) {
        console.error(e);
        this.$message.error('导出失败，请重试');
      } finally {
        this.exportLoading = false;
        this.loading = false;
      }
    },
  },
  computed: {
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
  },
};
</script>

<style scoped>
.container { padding: 20px; }
.title { font-size: 24px; font-weight: bold; margin-bottom: 30px; }
.search-container { padding: 20px; background-color: #fff; border-radius: 4px; }
.search-form { width: 100%; }
.search-button { display: flex; justify-content: flex-start; align-items: flex-start; margin-left: 10px; }
.el-form-item { margin-bottom: 18px; display: flex; }
.button-container { margin-bottom: 20px; display: flex; justify-content: flex-end; position: relative; }
.box-card { margin-bottom: 20px; }
.pagination-container { display: flex; justify-content: flex-end; }
.title-en { margin: 10px 0; padding-left: 10px; border-left: 3px solid #219aff; font-weight: normal; }
.checkbox-group { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; padding: 10px; max-height: 300px; overflow-y: auto; }
.checkbox-item { margin-right: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.dialog-footer { text-align: right; padding-top: 15px; border-top: 1px solid #ebeef5; }
.dialog-footer .el-button + .el-button { margin-left: 8px; }
.life-cycle {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 2px 0;
  min-width: 360px;
}
.life-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 78px;
}
.life-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #dcdfe6;
  box-sizing: border-box;
}
.life-dot.on {
  background: #67c23a;
  box-shadow: 0 0 0 3px rgba(103, 194, 58, 0.15);
}
.life-step-meta {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
}
.life-step-title {
  font-size: 12px;
  color: #909399;
  white-space: nowrap;
}
.life-step-time {
  font-size: 12px;
  color: #303133;
  white-space: nowrap;
}
.life-line {
  width: 20px;
  height: 4px;
  border-radius: 2px;
  background: #ebeef5;
  flex-shrink: 0;
}
.life-line.on {
  background: #67c23a;
}
.life-duration {
  margin-left: 8px;
  color: #303133;
  white-space: nowrap;
}
.sla-overdue { color: #f56c6c; font-weight: 600; }
.sla-ahead { color: #67c23a; font-weight: 600; }

::v-deep .el-date-editor.el-input__inner,
.el-date-editor--daterange.el-input__inner {
  width: 100% !important;
}

::v-deep .el-range-editor.el-input__inner {
  width: 100% !important;
}

::v-deep .el-date-editor .el-range-input {
  width: 66% !important;
}

::v-deep .el-range-editor--small .el-range-input {
  font-size: 12px !important;
}

::v-deep .el-select,
.el-input {
  width: 100% !important;
}

::v-deep .el-form-item__content {
  width: calc(100% - 10px) !important;
}
</style>
